import { ModelInput, ModelInputProps } from '../../../../..';

export function ModelAlphaInput(props: ModelInputProps) {
  return (
    <ModelInput {...props} mutateValue={(v) => v.replace(/[^a-z'-\s]/gmi, '')} />
  );
}
